<template>
  <v-footer
    id="core-footer"
    absolute
    height="82"
  >
    <div class="footer-items">
      <span
        v-for="link in links"
        :key="link.name"
      >
        <a
          :href="link.Link"
          class="tertiary--text footer-links">{{ link.name }}</a>
      </span>
    </div>
    <v-spacer/>
    <span class="font-weight-light copyright">
      &copy;
      {{ (new Date()).getFullYear() }}
      <a
        href="http://www.beian.miit.gov.cn"
        target="_blank">备案号：粤ICP备19120524号-1</a>
      <v-icon
        color="tertiary"
        size="17">mdi-heart</v-icon>
    </span>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    links: [
      { name: 'Home', Link: '/#' },
      { name: '备案号：粤ICP备19120524号-1', Link: 'http://www.beian.miit.gov.cn' }
    ]
  })
}
</script>

<style>
#core-footer {
  z-index: 0;
}
</style>
